const baseUrl = process.env.REACT_APP_API_URL;
const lmsUrl = process.env.REACT_APP_LMS_API_URL;
const tradingUrl = process.env.REACT_APP_TRADING_API_URL;
const contestUrl = process.env.REACT_APP_CONTEST_API_URL;
const fantasyUrl = process.env.REACT_APP_FANTASY_API_URL;

const HttpService = () => {
  return {
    socialSignin: baseUrl + "social-signin",
    login: baseUrl + "login",
    addReferral: baseUrl + "add-referral",
    signup: baseUrl + "signup",
    homePagePopups: baseUrl + "get-homepage-popups",
    sendotp: baseUrl + "resend-otp",
    verifyOtp: baseUrl + "verify-otp",
    verifyEmail: baseUrl + "verify_email",
    logout: baseUrl + "logout",
    deleteUser: baseUrl + "delete-user",
    notification : baseUrl + "notification",
    notificationMark: baseUrl + "notification/mark-read",   
    country: baseUrl + "country",
    state: baseUrl + "state",
    city: baseUrl + "city",
    getProfile: baseUrl + "get-profile",
    configdata: baseUrl + "config-variable",
    achiveRewards: baseUrl + "achieve-rewards",
    walletHistory: baseUrl + "wallet-history",
    getAvatar: baseUrl + "get-avatar",
    editProfile: baseUrl + "update-profile",
    SupportAd: baseUrl + "support-ad",
    cms : baseUrl + "cms",
    spinwheel : baseUrl + "spin-wheel",
    inSights : baseUrl + "insights",
    randomQuiz : baseUrl + "random-quiz-questions", 
    submitQuizQuestion: baseUrl + "submit-quiz-question",    
    quizHistory: baseUrl + "quiz-question-history",
    inAppPurchase: baseUrl + "in-app-purchase",
    subscriptions: baseUrl + "subscriptions",
    avatarCategory: baseUrl + "avatar-category",
    getAvatar: baseUrl + "get-avatar",
    badges: baseUrl + "badges",
    sendEmail : baseUrl + "send_email",
    levelHistory: baseUrl + "level-history",
    rakutenProductList: baseUrl + "rakuten-product-list",
    rakutenCouponList: baseUrl + "rakuten-coupon-list",
    userVoucherSaved: baseUrl + "save-user-voucher",
    userVoucherHistory: baseUrl + "user-voucher-history",
    getPaperTradingRule: baseUrl + "get-paper-trading-rule",
    getKeyTradingMatrics: baseUrl + "get-key-trading-matrics",
    earnCoinList: baseUrl + "earn-coin-list",
    userSubscriptionHistory: baseUrl + "user-subscription-history",
    trophyList: baseUrl + "trophy-list",
    validatePrivateCoupon: baseUrl + 'validate-private-coupons',
    tutorialVideoList: baseUrl + "tutorialVideo/list",
    myCompletedContests: contestUrl + "my-completed-contests",
    myCompletedFantasies: fantasyUrl + "my-completed-fantasies",
    contestTrophy: contestUrl + "contest-trophy",
    fantasyTrophy: fantasyUrl + "fantasy-trophy",
    downloadCertificate : lmsUrl + "download-certificate",    
    lmsListing: lmsUrl + "courses",
    lmsDetails: lmsUrl + "courses-details",
    registerUser : lmsUrl + "register-course",
    banners: lmsUrl + "banners",
    getLesson: lmsUrl + "get-lessons", 
    myLearning: lmsUrl + "my-learnings",    
    getTopics: lmsUrl + "get-topics",   
    getTopicsDetails: lmsUrl + "get-topics-details",
    restartQuiz: lmsUrl + "restart-quiz",
    downloadCourse: lmsUrl + "download-course",    
    submitQuestion : lmsUrl + "submit-question",
    getCertificates : lmsUrl + "get-certificates",
    payment: baseUrl + 'payments',
    getCompanies: tradingUrl + 'companies',
    sectors: tradingUrl + 'sectors',
    promoCode: baseUrl + 'promocode-list',
    myPortfoilo: tradingUrl + 'my-portfolio',
    toroGeneratedPortfolio: tradingUrl + 'toro-generated-portfolio',
    toroGeneratedPortfolioTag: tradingUrl + 'toro-generated-portfolio-tag',
    portfolioDetails: tradingUrl + 'portfolio-details',
    createPortfoilo: tradingUrl + 'create-portfolio',
    marketStatus: tradingUrl + 'market-status',
    tradingProfile: tradingUrl + 'trading-profile',
    allStocks: tradingUrl + 'all-stocks',
    deletePortfolio: tradingUrl + 'delete-portfolio',
    stockDetails: tradingUrl + 'stock-details',
    portfolioStockDetails: tradingUrl + 'portfolio-stock-details',
    contestsList: contestUrl + 'contests',
    contestDetails: contestUrl + 'contest-details',
    joinContest: contestUrl + 'join-contest',
    joinGameContest: contestUrl + 'join-game-contest',
    myContests: contestUrl + 'my-contests',
    myContestDetails: contestUrl + 'my-contest-details',
    cancelContest: contestUrl + 'cancel-contest',
    contestPrizeBreakup: contestUrl + 'contest-prize-breakup',
    createContest: contestUrl + 'create-contest',
    deleteContest: contestUrl + 'delete-contest',
    leaderboards: contestUrl + 'contest-details/leaderboards',
    opponentUserList: contestUrl + 'contest-details/opponent-user',
    tiers: contestUrl + 'tiers',
    gameTierList: contestUrl + 'game-tier-list',
    prizeCalculation: contestUrl + 'private-contests/prize-calculation',
    contestStockDetails: contestUrl + 'contest-stock-details',
    contestLeaderboard: contestUrl + 'contest-leaderboard',
    leaderboardRankRallycoins: contestUrl + 'leaderboard-rank-rallycoins',
    entryFeesPrizePoolMinMax: contestUrl + 'entry-fees-prize-pool-min-max',
    fantasyList: fantasyUrl + 'fantasy',
    fantasyDetails: fantasyUrl + 'fantasy-details',
    joinFantasy: fantasyUrl + 'join-fantasy',
    myFantasies: fantasyUrl + 'my-fantasies',
    myFantasyDetails: fantasyUrl + 'my-fantasy-details',
    myFantasyStockDetails: fantasyUrl + 'my-fantasy-stock-details',
    privateFantasy: fantasyUrl + 'private-fantasy',
    userFantasyStockData: fantasyUrl + 'user-fantasy-stock-data',
    updateFantasyPortfolio: fantasyUrl + 'update-fantasy-portfolio',
    fantasyLeaderboard: fantasyUrl + 'fantasy-leaderboard',
    fantasyLeaderboardRankRallycoins: fantasyUrl + 'leaderboard-rank-rallycoins',
    fantasyEntryFeesPrizePoolMinMax: fantasyUrl + 'entry-fees-prize-pool-min-max',
    // feedAPI:"https://www.alphavantage.co/query?function=NEWS_SENTIMENT&FOREX:USD&time_from=20240603T0030&limit=1000&apikey=GKXQ2E8TBYLT65N4",
    feedAPI: "https://finnhub.io/api/v1/news?category=general&token=cr7lh3pr01qotnb3lttgcr7lh3pr01qotnb3ltu0",
  };
};

export default HttpService;
